import QueryTable from '../query/remote/QueryTable';
import QueryTableStatus from '../query/remote/QueryTableStatus';
import QueryRelationJoinMode from '../query/remote/QueryRelationJoinMode';
import QueryRelationItem from '../query/remote/QueryRelationItem';
import QueryWhereItem from '../query/remote/QueryWhereItem';
import QueryWhereAndOr from '../query/remote/QueryWhereAndOr';
import QueryWhereStatus from '../query/remote/QueryWhereStatus';
import QueryWhereLeftBracket from '../query/remote/QueryWhereLeftBracket';
import QueryWhereRightBracket from '../query/remote/QueryWhereRightBracket';
import QueryOrderByItem from '../query/remote/QueryOrderByItem';
import QueryOrderByType from '../query/remote/QueryOrderByType';
import QueryRelation1N from '../query/remote/QueryRelation1N';
import FormItemTimeResolver from '../formItem/resolver/FormItemTimeResolver';
import FormItemDateResolver from '../formItem/resolver/FormItemDateResolver';
import GongqiDataType from '../remote/GongqiDataType';
import GOT from './GOT';
import GOTUtil from './GOTUtil';
import StringUtil from './StringUtil';
import FormItemUtil from './FormItemUtil';
import GOTPropertiesUtil from './GOTPropertiesUtil';
import QueryParentProperty from '../query/remote/QueryParentProperty';

import Warn from './Warn';
import QueryAggregationItem from '../query/remote/QueryAggregationItem';
import QueryWhereItemUn from '../universalView/remote/QueryWhereItem';

export default class QueryUtil
{
	static deleteUserQueryList(key)
	{
		let userQueryList  = window.userQueryList;
		if(!userQueryList)
		{
			userQueryList = window.parent.window.userQueryList;
		}

		delete userQueryList[key];
	}

	static setUserQueryList(key,value)
	{
		let userQueryList  = window.userQueryList;
		if(!userQueryList)
		{
			userQueryList = window.parent.window.userQueryList;
		}

		userQueryList[key] = value;
	}

	static getQueryList(key)
	{
		let userQueryList  = window.userQueryList;
		if(!userQueryList)
		{
			userQueryList = window.parent.window.userQueryList;
		}

		return userQueryList[key];
	}

	static hasQueryList(key)
	{
		let userQueryList  = window.userQueryList;
		if(!userQueryList)
		{
			userQueryList = window.parent.window.userQueryList;
		}

		return userQueryList.hasOwnProperty(key);
	}

	static isGroupJoin(type)
	{
		if(type=="InnerJoin"
			|| type=="ExistJoin"
			|| type=="NotExistJoin")
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	static buildBaseQueryTable(formDataSource,formDataSources)
	{
		var queryTable = {name:"A_QueryTable",id:"1",
						  Properties:{
						  	Table:{V:""},
						  	Alias:{V:""},
						  	UserUpdate:{V:true},
						  	Output:{V:true},
						  	Status:{V:"Open"}
						  },
						  QueryRelation:{
						  	Properties:{
						  		Auto:{V:false},
						      	JoinMode:{V:"None"},
						      	Relation1N:{V:"ManyToOne"},
						  	},
						  	Items:[]
						  },
						  QueryFields:{
						  	Properties:{
						  		Auto:{V:true},
						  	},
						  	Items:[]
						  },
						  QueryGroupBy:{name:"GroupBy"},
						  QueryOrderBy:{name:"OrderBy",Items:[]},
						  QueryWhere:{
						  	name:"Where",
						  	Items:[]
						  },
						  QueryAggregations:{
						  	name:"Aggregations",
						  	Items:[]
						  },
						  QueryJoins:{
						  	name:"Joins",
						  	Items:[]
						  }

		};		
		var joins = [];
		for(let i in formDataSources.DataSources)
		{
			var fds = formDataSources.DataSources[i];
			if(fds.Properties.JoinSource.Value == formDataSource.name &&
				QueryUtil.isGroupJoin(fds.Properties.JoinType.Value))
			{
				joins.push(fds);
			}
		}
		
		var tablePro = queryTable.Properties.Table;
		var aliasPro = queryTable.Properties.Alias;
		var outPutPro = queryTable.Properties.Output;
		
		var formTablePro = formDataSource.Properties.Table;
		
		if(!formTablePro.hasOwnProperty("refentityid"))
			throw new Error("GOT错误:FormDataSource没有与Table关联");
		
		
		tablePro.V = formTablePro.Value;
		aliasPro.V = formDataSource.name;
		
		tablePro.refentityid = formTablePro.refentityid;
		queryTable.id = formDataSource.id;
		queryTable.name = formDataSource.name;
		
		
		var queryRelation = queryTable.QueryRelation;
		var joinModePro = queryRelation.Properties.JoinMode;
		
		var formJoinTypeValue = formDataSource.Properties.JoinType.Value;
		
		if(formJoinTypeValue=="InnerJoin" || formJoinTypeValue=="ExistJoin" || formJoinTypeValue=="NotExistJoin")
		{
			joinModePro.V = formJoinTypeValue;
		}
		else
		{
			joinModePro.V = QueryRelationJoinMode.None;
		}
		
		if(joinModePro.V=="InnerJoin" || joinModePro.V==QueryRelationJoinMode.None)
		{
			outPutPro.V = "true";
		}
		else
		{
			outPutPro.V = "false";
		}
		
		var queryRelation1NPro = queryRelation.Properties.Relation1N;
		
		if(joinModePro.V=="InnerJoin" || joinModePro.V==QueryRelationJoinMode.None)
		{
			queryRelation1NPro.V = "ManyToOne";
		}
		else
		{
			queryRelation1NPro.V = "OneToMany";
		}
		
		if(joinModePro.V!=""&&joinModePro.V!=QueryRelationJoinMode.None)	//仅针对InnerJoin ExistJoin NotExistJoin
		{
			var relationItems  = formDataSource.FormDataSourceRelation ;
			for(let i = 0;i<relationItems.length;i++)
			{
				var relationItem = relationItems[i];
				var rtemp = {
					name:"A_QueryRelationItem",id:"2",
					Properties:{
						Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}
					}
				}
				rtemp.id = relationItem;
				QueryUtil.setQueryRelationByFormRelation(rtemp,relationItem,formDataSource);
				queryRelation.Items.push(rtemp);
			}
		}
		//当joinModePro.Value==""时，即 "" Delayed Active Passived时，relation关系不加在当前节点下，而是加到Auto_JoinParent的QueryRelation上
		
		var defaultOrderByPro = formDataSource.Properties.DefaultOrderBy;
		
		var queryOrderBy = queryTable.QueryOrderBy;
		
		var reverse = formDataSource.Properties.Reverse.Value;
		
		if(defaultOrderByPro.hasOwnProperty("refentityid"))
		{
			var tableId = defaultOrderByPro.refentityid;
			var tableIndexId = defaultOrderByPro.refinnerid;
			var tableIndex = GOT.getTableIndex(GOT.getTable(tableId),tableIndexId);
			var tableIndexItems = tableIndex.IndexItems;
			//order = 
		}
		else
		{
			var table = GOT.getTable(formTablePro.refentityid);
			var tableDefaultOrderByPro = table.Properties.DefaultOrderBy;
			if(tableDefaultOrderByPro.hasOwnProperty("innerid"))
			{
				tableId = table.id;
				tableIndexId = tableDefaultOrderByPro.innerid;
				tableIndex = GOT.getTableIndex(table,tableIndexId);
				tableIndexItems = tableIndex.IndexItems;
			}
		}
		
		var itemorder = "";
		if(tableIndexItems)
		{
			for(let i=0;i<tableIndexItems.length;i++)
			{
				var tableIndexItem = tableIndexItems[i];

				var queryOrderByItem = {
					name:"A_QueryOrderByItem",id:"5",
					Properties:{Field:{V:""},OrderBy:{V:"ASC"}}
				};
				
				var queryOrderByItemFieldPro = queryOrderByItem.Properties.Field;
				var orderByPro = queryOrderByItem.Properties.OrderBy;
				queryOrderByItemFieldPro.V = tableIndexItem.Properties.Field.V;
				//TODO 根据Table索引排序
				if(tableIndexItem.Properties.ArrayItem && tableIndexItem.Properties.ArrayItem.V)
					queryOrderByItemFieldPro.V += ("."+tableIndexItem.Properties.ArrayItem.V);
				queryOrderByItemFieldPro.refentityid = tableId;
				queryOrderByItemFieldPro.refinnerid = tableIndexItem.Properties.Field.innerid;
					
				itemorder = tableIndexItem.Properties.SortOrder.V;
					
				if(reverse == "true" || reverse == true)
					itemorder = (itemorder=="ASC"?"DESC":"ASC");
				orderByPro.V = itemorder;
				queryOrderByItem.name = 
					queryOrderByItemFieldPro.V+" # "+itemorder;

				queryOrderBy.Items.push(queryOrderByItem);
			}
		}
		
		
		var queryJoins = queryTable.QueryJoins;
		for(let i=0;i<joins.length;i++)
		{
			let formDataSource = joins[i];
			queryJoins.Items.push(QueryUtil.buildBaseQueryTable(formDataSource,formDataSources)); 
		}
		
		return queryTable;

	}

	static setQueryRelationByFormRelation(queryRelation,formRelation,formDataSource)
	{
		queryRelation.name = formRelation.name;
		var queryRelationFieldPro = queryRelation.Properties.Field;
		var queryRelationRelatedFieldPro = queryRelation.Properties.RelatedField ||
											queryRelation.Properties.ParentField;
		
		var formRelationFieldPro = formRelation.Properties.Field;
		var formRelationRelatedFieldPro = formRelation.Properties.RelatedField ||
											formRelation.Properties.ParentField;
		if(!formRelationFieldPro)formRelaionFieldPro = {};
		if(!formRelationRelatedFieldPro)formRelationRelatedFieldPro = {};
		var fieldRefEntityId = formRelationFieldPro.refentityid;
		var fieldRefInnerId = formRelationFieldPro.refinnerid;
		var relatedRefEntityId = formRelationRelatedFieldPro.refentityid;
		var relatedRefInnerId = formRelationRelatedFieldPro.refinnerid;
		
		if(formRelation.type == "Normal")
		{
			queryRelationFieldPro.V = formRelationRelatedFieldPro.Value;
			queryRelationFieldPro.refentityid = relatedRefEntityId;
			queryRelationFieldPro.refinnerid = relatedRefInnerId;
			queryRelationRelatedFieldPro.V = formRelationFieldPro.Value;
			queryRelationRelatedFieldPro.refentityid = fieldRefEntityId;
			queryRelationRelatedFieldPro.refinnerid = fieldRefInnerId;
		}
		else if(formRelation.type == "Fixed")
		{
			formRelationFieldPro = formRelation.Properties.Field;
			//queryRelationFieldPro.V = formRelationFieldPro.Value;
			queryRelationRelatedFieldPro.V = formRelationFieldPro.Value;
			//queryRelationFieldPro.refentityid = fieldRefEntityId;
			queryRelationRelatedFieldPro.refentityid = fieldRefEntityId;
			//queryRelationFieldPro.refinnerid = fieldRefInnerId;
			queryRelationRelatedFieldPro.refinnerid = fieldRefInnerId;

			var formRelationValuePro = GOTUtil.getProperty(formRelation,"Value");
			var queryRelationFixedPro = GOTUtil.getProperty(queryRelation,"RelatedValue");
			queryRelationFixedPro.V = formRelationValuePro.Value;
		}
		else if(formRelation.type == "RelatedFixed")
		{
			formRelationRelatedFieldPro = formRelation.Properties.ParentField ||
											formRelation.Properties.RelatedField;
			//queryRelationRelatedFieldPro.V = formRelationRelatedFieldPro.Value;
			queryRelationFieldPro.V = formRelationRelatedFieldPro.Value;
			//queryRelationRelatedFieldPro.refentityid = relatedRefEntityId;
			queryRelationFieldPro.refentityid = relatedRefEntityId;
			//queryRelationRelatedFieldPro.innerid = relatedRefInnerId;
			queryRealtionFieldPro.innerid = relatedRefInnerId;

			formRelationValuePro = GOTHelper.getProperty(formRelation,"Value");
			var queryRelationRelatedValuePro = GOTHelper.getProperty(queryRelation,"FieldValue");
			queryRelationRelatedValuePro.V = formRelationValuePro.Value;
		}
	}

	static formatTimeValue(time)
	{
		var reg = /\d([:\d]*)\d/g;  
		return time.replace(reg,QueryUtil.replFunTime);
	}
	
	static replFunTime(time)
	{
		return FormItemTimeResolver.getResult(time);
	}
	
	static formatDateValue(date)
	{
		var reg = /\d([-\d]*)\d/g;  
		return date.replace(reg,QueryUtil.replFunDate);
	}

	static formatBooleanValue(value)
	{
		if(typeof(value) == "string")
		{
			value = value.replace("是","true");
			value = value.replace("1","true");
			value = value.replace("否","false");
			value = value.replace("0","false");	
		}
		return value;
	}

	static formatEnumValue(value,entityId,innerId)
	{
		if(typeof(value) != "string")
			return value;
		var array = [];
		var array1 = value.split(",");
		for(let i = 0;i<array1.length;i++)
		{
			var s1 = array1[i];
			var array2 = s1.split("..");
			for(let k = 0;k<array2.length;k++)
			{
				var s2 = array2[k];
				if(isNaN(parseInt(s2)))
				{
					array.push(s2);		
				}
			}
					
		}
		
		for(let i = 0;i<array.length;i++)
		{
			var a = array[i];
			//var _key = FormItemUtil.getFormStoresKey(window.menuItemId,entityId);
			//var formStore = window[_key];
			var _properties = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,entityId,innerId);
				//formStore.mapItemProperty[entityId+"_"+innerId];
			var _dataProvider = _properties.DataProvider;
			for(let k = 0;k<_dataProvider.length;k++)
			{
				var item = _dataProvider[k];
				if(item.hasOwnProperty("label") && item.label == a)
				{
					value = value.replace(a,item.value)
				}
			}
			
		}
		
		return value;
	}
		

	static replFunDate(date)
	{
		return FormItemDateResolver.getResult(date);
	}

	static formatValue(fieldValue,property)
	{
		var entityId = property.refentityid;
		var innerId =  property.refinnerid;
		var table = GOT.getTable(entityId);
		var tableField = GOT.getTableField(table,innerId);
		if(tableField != null)
		{
			if(tableField.type == "Time")
				return QueryUtil.formatTimeValue(fieldValue);
			else if(tableField.type == "Date")
				return QueryUtil.formatDateValue(fieldValue);
			else if(tableField.type == "Boolean")
				return QueryUtil.formatBooleanValue(fieldValue);
			else if(tableField.type == "Enum")
				return QueryUtil.formatEnumValue(fieldValue,entityId,innerId);
		}
		return fieldValue;
	}

	static getFieldType(propertyXML)
	{
		var entityId = propertyXML.refentityid;
		var innerId =  propertyXML.refinnerid;
		var table = GOT.getTable(entityId);
		var tableField = GOT.getTableField(table,innerId);
		if(tableField == null)return "";
		
		var type = tableField.type;
		if(type==GongqiDataType.TypeComponent)
		{
			type = GongqiDataType.TypeString;
		}
		return "Type"+type; 
	}

	static convertXML2QueryTable(query,parent=null)
	{
		if(query == null)
			return null;
		
		var queryTable = new QueryTable();
		let queryParentProperty = null;
		if(parent)
		{
			queryParentProperty = new QueryParentProperty();
			queryParentProperty.tableId = parent.tableId;
			queryParentProperty.tableName = parent.tableName;
			queryParentProperty.aliasName = parent.aliasName;	
		}
		
		queryTable.parentProperty = queryParentProperty;
		var eQueryTable;
		
		if(query.qname == "Query")
			eQueryTable = query.QueryTable;
		else
			eQueryTable = query;
				
		var pTable = eQueryTable.Properties.Table;
		queryTable.tableId = pTable.refentityid;
		queryTable.tableName = pTable.V;
		queryTable.aliasName = eQueryTable.Properties.Alias.V;
		
		queryTable.output = eQueryTable.Properties.Output.V;
		queryTable.isTempTable = eQueryTable.tempTable;
		queryTable.status = QueryTableStatus.valueOf(eQueryTable.Properties.Status.V);
		
		var eQueryRelation = eQueryTable.QueryRelation;
		
		queryTable.relationJoinMode = QueryRelationJoinMode.valueOf(eQueryRelation.Properties.JoinMode.V);
		queryTable.relation1N = QueryRelation1N.valueOf(eQueryRelation.Properties.Relation1N.V);
		
		var entityId;
		var innerId;
		var table;
		var tableField;
		var listRelations = eQueryRelation.Items;
		var fieldValue;
		var propertyXML;
		var queryRelations = [];
		if(listRelations.length>0)
		{
			for(var i in listRelations)
			{
				var eRelation = listRelations[i];
				var queryRelationItem = new QueryRelationItem();
				
				propertyXML = eRelation.Properties.Field;
				queryRelationItem.tableId = propertyXML.refentityid;
				queryRelationItem.fieldId = propertyXML.refinnerid;
				
				if(eRelation.hasOwnProperty("dataField"))
					queryRelationItem.dataField = eRelation.dataField;
				
				queryRelationItem.fieldName = propertyXML.V;
				fieldValue = eRelation.Properties.FieldValue.V;
				if(queryRelationItem.fieldName != "")
				{
					fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
					queryRelationItem.fieldType = QueryUtil.getFieldType(propertyXML);
				}
				queryRelationItem.fieldValue = fieldValue=="null"?null:fieldValue;
				 
				
				propertyXML = eRelation.Properties.ParentField||eRelation.Properties.RelatedField;
				queryRelationItem.relatedTableId = propertyXML.refentityid;
				queryRelationItem.relatedFieldId = propertyXML.refinnerid;
				queryRelationItem.relatedFieldName = propertyXML.V;
				fieldValue = eRelation.Properties.RelatedValue.V;
				if(queryRelationItem.relatedFieldName != "")
				{
					fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
					queryRelationItem.fieldType = QueryUtil.getFieldType(propertyXML);
				}
				queryRelationItem.relatedFieldValue = fieldValue=="null"?null:fieldValue;
				
				queryRelations.push(queryRelationItem);
			}
			
		}
		queryTable.queryRelations = queryRelations;
		
		var listWhere = eQueryTable.QueryWhere.Items;
		var queryWhereItems = [];
		
		for(var i=0;i<listWhere.length;i++)
		{
			var eWhere = listWhere[i];
			var queryWhereItem = new QueryWhereItem();
			propertyXML = eWhere.Properties.Field;
			queryWhereItem.tableId = propertyXML.refentityid;
			queryWhereItem.fieldId = propertyXML.refinnerid;
			queryWhereItem.fieldName = propertyXML.V;
			fieldValue = eWhere.Properties.Value.V;
			if(queryWhereItem.fieldName != "")
			{
				fieldValue = QueryUtil.formatValue(fieldValue, propertyXML);
				queryWhereItem.fieldType = QueryUtil.getFieldType(propertyXML);
			}
			queryWhereItem.fieldValue = fieldValue;
			queryWhereItem.andOr = QueryWhereAndOr.valueOf(eWhere.Properties.AndOr.V);
			queryWhereItem.leftBracket = QueryWhereLeftBracket.valueOf(eWhere.Properties.LeftBracket.V);
			queryWhereItem.rightBracket = QueryWhereRightBracket.valueOf(eWhere.Properties.RightBracket.V);
			queryWhereItem.label = eWhere.Properties.Label.V;
			queryWhereItem.status = QueryWhereStatus.valueOf(eWhere.Properties.Status.V);
			queryWhereItem.tag = eWhere.tag;
			if(queryWhereItem.tag==null)
				queryWhereItem.tag = "";
			//queryWhereItems.push(queryWhereItem);
			queryWhereItems.push(queryWhereItem);
			
		}
		queryTable.queryWhere = queryWhereItems;
		
		var listOrderByItems = eQueryTable.QueryOrderBy.Items;
		var queryOrderByItems = [];
		if(listOrderByItems.length>0)
		{
			for(var i=0;i<listOrderByItems.length;i++)
			{
				var eOrderBy = listOrderByItems[i];
				var queryOrderByItem = new QueryOrderByItem();
				propertyXML = eOrderBy.Properties.Field;
				queryOrderByItem.tableId = propertyXML.refentityid;
				queryOrderByItem.fieldId = propertyXML.refinnerid;
				queryOrderByItem.fieldName = propertyXML.V;
				queryOrderByItem.orderBy = QueryOrderByType.valueOf(eOrderBy.Properties.OrderBy.V);
				queryOrderByItems.push(queryOrderByItem);
			}
			
		}
		queryTable.queryOrderBy = queryOrderByItems;

		var listAggregationItems = eQueryTable.QueryAggregations.Items;
		var queryAggregationItems = [];
		if(listAggregationItems.length>0)
		{
			for(let i = 0;i<listAggregationItems.length;i++)
			{
				var eQueryAggregationItem = listAggregationItems[i];
				//eQueryAggregationItem.remoteClass = "gongqi.erp.gotmodel.query.QueryAggregationItem";
				var queryAggregationItem = new QueryAggregationItem();
				Object.assign(queryAggregationItem,eQueryAggregationItem)
				queryAggregationItems.push(queryAggregationItem);
			}
		}
		queryTable.queryAggregation = queryAggregationItems;
		
		var listJoins = eQueryTable.QueryJoins.Items;
		var queryJoins = [];
		if(listJoins.length>0)
		{
			for(var i=0;i<listJoins.length;i++)
			{
				var eJoinQueryTable = listJoins[i];
				var cQueryTable = QueryUtil.convertXML2QueryTable(eJoinQueryTable,queryTable);
				queryJoins.push(cQueryTable);
			}
			
		}
		queryTable.queryJoins = queryJoins;
		
		return queryTable;
	}

	static getInnerId(base)
	{
		var nextInnerId = base.nextInnerId;
		base.nextInnerId = (nextInnerId + 1);
		return nextInnerId;
	}

	static convertQueryTable2XML(queryTable,base)
	{
		if(!queryTable)
			return null;
		
		var eQueryTable;
		eQueryTable = {name:"A_QueryTable",id:"1",
						  Properties:{
						  	Table:{V:""},
						  	Alias:{V:""},
						  	UserUpdate:{V:true},
						  	Output:{V:true},
						  	Status:{V:"Open"}
						  },
						  QueryRelation:{
						  	Properties:{
						  		Auto:{V:false},
						      	JoinMode:{V:"None"},
						      	Relation1N:{V:"ManyToOne"},
						  	},
						  	Items:[]
						  },
						  QueryFields:{
						  	Properties:{
						  		Auto:{V:true},
						  	},
						  	Items:[]
						  },
						  QueryGroupBy:{name:"GroupBy"},
						  QueryOrderBy:{name:"OrderBy",Items:[]},
						  QueryWhere:{
						  	name:"Where",
						  	Items:[]
						  },
						  QueryAggregations:{
						  	name:"Aggregations",
						  	Items:[]
						  },
						  QueryJoins:{
						  	name:"Joins",
						  	Items:[]
						  }

		};
		
		GOTUtil.getProperty(eQueryTable, "Table").V = queryTable.tableName;
		GOTUtil.getProperty(eQueryTable, "Table").refentityid = queryTable.tableId;
		GOTUtil.getProperty(eQueryTable, "Alias").V = queryTable.aliasName;
		
		GOTUtil.getProperty(eQueryTable, "Output").V = queryTable.output;
		GOTUtil.getProperty(eQueryTable, "Status").V = QueryTableStatus.getLabel(queryTable.status);
		
		eQueryTable.id = QueryUtil.getInnerId(base);
		eQueryTable.name = queryTable.aliasName;
		eQueryTable.tempTable = queryTable.isTempTable;
		
		
		var eQueryRelation = eQueryTable.QueryRelation;
		
		GOTUtil.getProperty(eQueryRelation, "JoinMode").V = QueryRelationJoinMode.labelOf(queryTable.relationJoinMode);
		GOTUtil.getProperty(eQueryRelation, "Relation1N").V = QueryRelation1N.labelOf(queryTable.relation1N);
		
		var innerId;
		var tableField;
		var fieldValue;
		var propertyXML;
		
		if(queryTable.queryRelations && queryTable.queryRelations.length>0)
		{
			for(let i = 0;i<queryTable.queryRelations.length;i++)
			{
				let queryRelationItem = queryTable.queryRelations[i];
				var eRelationItem = {qname:"QueryRelationItem",name:"A_QueryRelationItem",id:"2",
													Properties:{Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}}
												  };
				var name;
				
				if(queryRelationItem.fieldName)
					GOTUtil.getProperty(eRelationItem, "Field").V = queryRelationItem.fieldName;
				if(queryRelationItem.fieldValue)
					GOTUtil.getProperty(eRelationItem, "FieldValue").V = queryRelationItem.fieldValue;
				if(queryRelationItem.tableId)
					GOTUtil.getProperty(eRelationItem, "Field").refentityid = queryRelationItem.tableId;
				if(queryRelationItem.fieldId)
					GOTUtil.getProperty(eRelationItem, "Field").refinnerid = queryRelationItem.fieldId;
				if(queryRelationItem.relatedFieldName)
					GOTUtil.getProperty(eRelationItem, "ParentField").V = queryRelationItem.relatedFieldName;
				if(queryRelationItem.relatedFieldValue)
					GOTUtil.getProperty(eRelationItem, "RelatedValue").V = queryRelationItem.relatedFieldValue;
				if(queryRelationItem.relatedTableId)
					GOTUtil.getProperty(eRelationItem, "ParentField").refentityid = queryRelationItem.relatedTableId;
				if(queryRelationItem.relatedFieldId)
					GOTUtil.getProperty(eRelationItem, "ParentField").refinnerid = queryRelationItem.relatedFieldId;
				if(queryRelationItem.dataField)
					eRelationItem.dataField = queryRelationItem.dataField;
				
				eQueryRelation.Items.push(eRelationItem);
				eRelationItem.id = QueryUtil.getInnerId(base);

				if(queryRelationItem.fieldName && queryRelationItem.fieldName != "" 
					&& queryRelationItem.fieldValue && queryRelationItem.fieldValue != "")
				{
					eRelationItem.name = queryTable.tableName + "." + queryRelationItem.fieldName + "=" + queryRelationItem.fieldValue;
				}
				else if(queryRelationItem.fieldName && queryRelationItem.fieldName != ""
					&& queryRelationItem.relatedFieldName && queryRelationItem.relatedFieldName != "")
				{
					eRelationItem.name = queryTable.tableName + "." + queryRelationItem.fieldName + "=" + queryTable.parentProperty.tableName + "." + queryRelationItem.relatedFieldName;
				}
				else if(queryRelationItem.relatedFieldName && queryRelationItem.relatedFieldName != ""
					&& queryRelationItem.relatedFieldValue && queryRelationItem.relatedFieldValue != "")
				{
					eRelationItem.name = queryTable.parentProperty.tableName + "." + queryRelationItem.relatedFieldName + "=" + queryRelationItem.relatedFieldValue;
				}
			}
		}
		
		var eQueryWhere = eQueryTable.QueryWhere;
		
		if(queryTable.queryWhere && queryTable.queryWhere.length>0)
		{

			for(let i = 0;i<queryTable.queryWhere.length;i++)
			{
				var queryWhereItem  = queryTable.queryWhere[i];
				var eWhereItem = {qname:QueryWhereItem,name:"A_QueryWhereItem",id:6,Properties:{
					Field:{V:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},RightBracket:{V:"None"},
					Label:{V:""},Status:{V:"Open"},Enabled:{V:true}
				}};
				GOTUtil.getProperty(eWhereItem, "Field").V = queryWhereItem.fieldName;
				
				if(queryWhereItem.fieldValue)
					GOTUtil.getProperty(eWhereItem, "Value").V = queryWhereItem.fieldValue;
				
				GOTUtil.getProperty(eWhereItem, "Field").refentityid = queryWhereItem.tableId;
				GOTUtil.getProperty(eWhereItem, "Field").refinnerid = queryWhereItem.fieldId;
				
				GOTUtil.getProperty(eWhereItem, "AndOr").V = QueryWhereAndOr.labelOf(queryWhereItem.andOr);
				GOTUtil.getProperty(eWhereItem, "LeftBracket").V = QueryWhereLeftBracket.labelOf(queryWhereItem.leftBracket);
				GOTUtil.getProperty(eWhereItem, "RightBracket").V = QueryWhereRightBracket.labelOf(queryWhereItem.rightBracket);

				if(queryWhereItem.label)
					GOTUtil.getProperty(eWhereItem, "Label").V = queryWhereItem.label;
				
				GOTUtil.getProperty(eWhereItem, "Status").V = QueryWhereStatus.getLabel(queryWhereItem.status);
				eQueryWhere.Items.push(eWhereItem);
				eWhereItem.id = QueryUtil.getInnerId(base);
				
				eWhereItem.name = queryWhereItem.fieldName + "#" + queryWhereItem.fieldValue;
				
				if(queryWhereItem.tag)
				{
					eWhereItem.tag = queryWhereItem.tag;
				}
				else
				{
					eWhereItem.tag = "";
				}
				
			}
		}
		
		var eQueryOrderBy = eQueryTable.QueryOrderBy;
		
		if(queryTable.queryOrderBy && queryTable.queryOrderBy.length>0)
		{

			for(let i = 0;i<queryTable.queryOrderBy.length;i++)
			{
				var queryOrderByItem = queryTable.queryOrderBy[i];
				var eOrderByItem = {
					name:"A_QueryOrderByItem",id:5,Properties:{Field:{V:""},OrderBy:{V:"ASC"}}
				};
				GOTUtil.getProperty(eOrderByItem, "Field").V = queryOrderByItem.fieldName;
				var orderByType;
				if(queryOrderByItem.orderBy==QueryOrderByType.DESC)
				{
					orderByType = "DESC";
				}
				else
				{
					orderByType = "ASC";
				}
				GOTUtil.getProperty(eOrderByItem, "OrderBy").V = orderByType;
				GOTUtil.getProperty(eOrderByItem, "Field").refentityid = queryOrderByItem.tableId;
				GOTUtil.getProperty(eOrderByItem, "Field").refinnerid = queryOrderByItem.fieldId;
				
				eQueryOrderBy.Items.push(eOrderByItem);
				eOrderByItem.id = QueryUtil.getInnerId(base);

				eOrderByItem.name = queryOrderByItem.fieldName + "#" + orderByType;
			}
		}

		//aggregation 客户端不会使用 直接原样保存并返回给后台
		var eQueryAggregations = eQueryTable.QueryAggregations;

		if(queryTable.queryAggregation && queryTable.queryAggregation.length>0)
		{
			for(let i = 0;i<queryTable.queryAggregation.length;i++)
			{
				let queryAggregationItem = queryTable.queryAggregation[i];
				eQueryAggregations.Items.push(queryAggregationItem);
			}
		}
		
		var eQueryJions = eQueryTable.QueryJoins;
		
		if(queryTable.queryJoins && queryTable.queryJoins.length>0)
		{

			for(let i = 0;i<queryTable.queryJoins.length;i++)
			{
				var queryJion = queryTable.queryJoins[i];
				eQueryJions.Items.push(QueryUtil.convertQueryTable2XML(queryJion,base));
			}
		}	
		return eQueryTable;
	}

	static createWhereItemByField(tableField,field,alias,query,value = null)
	{
		var queryTable = GOTUtil.getQueryTableByAlias(alias,query);
		var queryTableTablePro = queryTable.Properties.Table;
		var queryWhere = queryTable.QueryWhere;
		
		var queryWhereItem = {qname:QueryWhereItem,name:"A_QueryWhereItem",id:6,Properties:{
			Field:{V:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},RightBracket:{V:"None"},
			Label:{V:""},Status:{V:"Open"},Enabled:{V:true}
		}};

		var fieldPro = queryWhereItem.Properties.Field;
		
		var temp = query.nextInnerId;
		queryWhereItem.id = temp;
		temp ++;
		query.nextInnerId = temp;
		queryWhereItem.name = field + " # " + value;
		fieldPro.V = field;
		fieldPro.refentityid = queryTableTablePro.refentityid;
		var _table = GOT.getTable(queryTableTablePro.refentityid);
		var refTableField = GOT.getTableField(_table,tableField);
		fieldPro.refinnerid = refTableField?refTableField.id:"";
		if(value!=null)
		{
			var valuePro = queryWhereItem.Properties.Value;
			if(value == "" && typeof(value) == "string"){
				value = "''";
			}
			if(refTableField && (refTableField.type == 'Date' || refTableField.type == 'Time') && value == "''"){
				value = "#null";
			}
			valuePro.V = value;
		}
		queryWhere.Items.push(queryWhereItem);
	}

	static dataSetViewcreateWhereItemByField(tableField,field,alias,query,value = null)
	{
		for(let j in query.QueryInteraction.Items){
			var queryWhereItem = new QueryWhereItemUn();
			let item = query.QueryInteraction.Items[j];
			if(tableField == item.Properties.Field.V  || tableField == item.Properties.Alias.V){
				queryWhereItem.qname= QueryWhereItem;
				queryWhereItem.tableId=item.Properties.TableId.V;	//String
				queryWhereItem.fieldId=item.Properties.Field.refinnerid;	//String
				var tableFiled = GOT.getTableFieldById(item.Properties.Field.refentityid,item.Properties.Field.refinnerid);
				if((item.Properties.Field.V) && (item.Properties.Field.V).indexOf(".") == -1){
					queryWhereItem.fieldName=tableFiled.name;//String
				}else{
					let sp = item.Properties.Field.V.split(".");
					let newfile = '';
					for(let k =0; k<sp.length;k++){
						if(newfile==''){
							newfile = sp[k];
						}else{
							newfile=newfile+"_"+sp[k];
						}
					}
					queryWhereItem.fieldName=newfile;
				}

				// if(value.indexOf(">=") != -1 || value.indexOf("<=") != -1  || value.indexOf("<>") != -1 ) {
				// 	value = value.slice(0,2)+"\'"+value.slice(2)+"\'"; 
				// }
				queryWhereItem.value=value;	//String
				queryWhereItem.andOr="And";	//String
				queryWhereItem.leftBracket="None";		//String	//QueryWhereLeftBracket
				queryWhereItem.rightBracket="None";	//String	//QueryWhereRightBracket
					
				queryWhereItem.label="";	//String
				queryWhereItem.status="Open";	//String			//QueryWhereStatus
				queryWhereItem.fieldType="Type"+tableFiled.type;	//String	//QueryWhereFieldType
				queryWhereItem.tag="";	//String
				//queryWhereItem.type="";
				//queryWhereItem.fieldValue = value;
				for(let i in query.queryWhere){
					if(query.queryWhere[i].tableId === query.tableId && query.queryWhere[i].fieldId === item.Properties.Field.refinnerid && query.queryWhere[i].andOr === "And"){
						if(query.queryWhere[i].fieldType == "TypeDate"){
							if((value.indexOf(">=") != -1 && query.queryWhere[i].value.indexOf(">=") != -1) 
							|| (value.indexOf("<=") != -1 && query.queryWhere[i].value.indexOf("<=") != -1) 
							||  (value.indexOf("<>") != -1 && query.queryWhere[i].value.indexOf("<>") != -1)){
								query.queryWhere.splice(i, 1);
							}
						}else{
							query.queryWhere.splice(i, 1);
						}
					}
				}
				if(query.tableId == item.Properties.TableId.V){
					if(value.indexOf("<>") == -1){
						query.queryWhere.push(queryWhereItem);
					}
				}else if(query.queryJoins.length>0){
					for(let h in query.queryJoins){
						query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
						this.dataSetViewcreateWhereItemByField(item.Properties.Field.V,item.Properties.Field.V,alias,query.queryJoins[h],value);
					}
				}
			}
		}
	}

	static reverseOrderBy(queryOrderByCollection)
	{
		if(!queryOrderByCollection)
			return;
		
		for(var i=0;i<queryOrderByCollection.length;i++)
		{
			var queryOrderByItem = queryOrderByCollection[i];
			if(queryOrderByItem.orderBy==QueryOrderByType.ASC)
				queryOrderByItem.orderBy = QueryOrderByType.DESC;
			else
				queryOrderByItem.orderBy = QueryOrderByType.ASC;
		}
	}

	static getQueryTableByName(query,name)
	{
		var items = query.QueryTable.QueryJoins.Items;
		for(let i = 0;i<items.length;i++)
		{
			var item = items[i];
			if(item.name == name)
				return item;
		}
		return null;
	}

	static getQueryTableByAlias2(alias, queryTable)
	{
		if(!alias || !queryTable)
			return null;
		
		var _alias = GOTUtil.getPropertyValue(queryTable, "Alias");
		if(_alias==alias)
			return queryTable;
		var _alias2 = GOTUtil.getPropertyValue(queryTable,"Table");
		if(_alias2 == alias)
			return queryTable;
		if(!queryTable.QueryJoins)
			return null;
		
		var list = queryTable.QueryJoins.Items;
		if(!list || list.length==0)
			return null;
		
		for(let i = 0;i<list.length;i++)
		{
			var qt = list[i];
			var result = QueryUtil.getQueryTableByAlias2(alias, qt);
			if(result)
				return result;
		}
		
		return null;
	}

	static getQueryTableByAlias(alias,query)
	{
		var queryTable = QueryUtil.getQueryTableByAlias2(alias, query.QueryTable);
		if(!queryTable)
			throw new Error("queryTable can't find");
		
		return queryTable;
	}

	static getQueryTableById2(id,queryTable)
	{
		if(!id || !queryTable)
			return null;
		
		
		if(id==queryTable.id)
			return queryTable;
		
		if(!queryTable.QueryJoins)
			return null;
		
		var list = queryTable.QueryJoins.Items;
		if(!list || list.length==0)
			return null;
		
		for(let i = 0;i<list.length;i++)
		{
			var qt = list[i];
			var result = QueryUtil.getQueryTableById2(id, qt);
			if(result)
				return result;
		}
		
		return null;
	}

	static getQueryTableById(id,query)
	{
		var queryTable = QueryUtil.getQueryTableById2(id, query.QueryTable);
		return queryTable;
	}

	static getQueryRelationItemByProperty(queryTable,dataField)
	{
		var result = [];
		var items = queryTable.QueryRelation.Items;
		for(var i = 0;i<items.length;i++)
		{
			var queryRelationItem = items[i];
			if(queryRelationItem.hasOwnProperty(dataField))
			{
				result.push(queryRelationItem);
			}
		}
		return result;
	}

	static consQueryByQuery(formQuery)
	{
		var query = formQuery;
		var queryTable1 = QueryUtil.getQueryTableByName(query,"Auto_JoinParent");
		var refentityid = queryTable1.Properties.Table.refentityid;
		var tableR1 = GOT.getTable(refentityid);
		var tableR1Id = tableR1.id;
		
		var tableRNPro = query.QueryTable.Properties.Table;
		if(!tableRNPro.hasOwnProperty("refentityid"))
			throw new Error("DataSource没有关联Table");
		var tableRNId = tableRNPro.refentityid;
		var tableRN = GOT.getTable(tableRNId);
		
		
		// add RelationItem
		var queryTable1Relation = queryTable1.QueryRelation;
		//var tableRNRelations = tableRN.TableRelations.Relations;
		var fieldRelations = [];
		var queryTable1RelationItem;
		var flag = false;
		/*for(var i = 0;i<tableRNRelations.length;i++)
		{
			var tableRNRelation = tableRNRelations[i];
			if(tableRNRelation.Properties.Table.V == tableR1.name)
			{
				var tableRelationItems = tableRNRelation.RelationItems;
				for(var k = 0;k<tableRelationItems.length;k++)
				{
					var tableRNRelationItem = tableRelationItems[k];
					var type = tableRNRelationItem.type;

					queryTable1RelationItem = {qname:"QueryRelationItem",name:"A_QueryRelationItem",id:"2",
						Properties:{Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}}
					};
					if(type == "Normal")
					{
						flag = true;
						var fieldPro = tableRNRelationItem.Properties.Field;
						
						var relatedFieldPro = tableRNRelationItem.Properties.RelatedField
												|| tableRNRelationItem.Properties.ParentField;
							
						fieldRelations.push({id:relatedFieldPro.refinnerid,value:relatedFieldPro.V});
						
						queryTable1RelationItem.Properties.Field.V = relatedFieldPro.Value;
						queryTable1RelationItem.Properties.Field.refentityid = relatedFieldPro.refentityid;
						queryTable1RelationItem.Properties.Field.refinnerid = relatedFieldPro.refinnerid;
						queryTable1RelationItem.Properties.ParentField.V = fieldPro.V;
						
						queryTable1RelationItem.Properties.ParentField.refentityid = tableRN.id;
						queryTable1RelationItem.Properties.ParentField.refinnerid = fieldPro.innerid;
						queryTable1RelationItem.name = tableR1.name + "." + relatedFieldPro.V + "=" + tableRN.name + "." + fieldPro.V;
						
						
						
					}
					else if(type == "Fixed")
					{
						fieldPro = tableRNRelationItem.Properties.Field;
						valuePro = tableRNRelationItem.Properties.Value;
						queryTable1RelationItem.Properties.ParentField.V = fieldPro.V;
						queryTable1RelationItem.Properties.ParentField.refentityid = fieldPro.refentityid;
						queryTable1RelationItem.Properties.ParentField.refinnerid = fieldPro.refinnerid;
						queryTable1RelationItem.Properties.RelatedValue.V = valuePro.V;
						queryTable1RelationItem.name = tableRN.name + "." + fieldPro.V + "=" + valuePro.V;
					}
					else if(type == "RelatedFixed")
					{
						relatedFieldPro = tableRNRelationItem.Properties.RelatedField
											|| tableRNRelationItem.Properties.ParentField;
						var valuePro = tableRNRelationItem.Properties.Value;
						queryTable1RelationItem.Properties.Field.V = relatedFieldPro.V;
						queryTable1RelationItem.Properties.Field.refentityid = relatedFieldPro.refentityid;
						queryTable1RelationItem.Properties.Field.refinnerid = relatedFieldPro.refinnerid;
						queryTable1RelationItem.Properties.FieldValue.V = valuePro.V;
						queryTable1RelationItem.name = tableR1.name + "." + relatedFieldPro.V + "=" + valuePro.V;	
					}
					
					queryTable1Relation.Items.push(queryTable1RelationItem);
					if(type=="Normal")
					{
						var rtemp2 = JSON.parse(JSON.stringify(queryTable1RelationItem));
						
						var sDataField;
						var pFieldForDataField = rtemp2.Properties.Field;
						sDataField = pFieldForDataField.V;
						sDataField = sDataField.substr(0,1).toLowerCase() + sDataField.substring(1);
						rtemp2.dataField = sDataField;
						
						var pField = rtemp2.Properties.ParentField;
							
						pField.V = "";
						delete pField.refentityid;
						delete pField.refinnerid;
						
						queryTable1Relation.Items.push(rtemp2);
					}
					
				}
				
				break;
			}
		}*/
		
		//find dataType
		if(!flag)
		{		
			var tableRNFields = tableRN.TableFields;
			for(var i = 0;i<tableRNFields.length;i++)
			{
				var tableRNField = tableRNFields[i];
				var extendsDataType = tableRNField.Properties.Extends.V;
				if(extendsDataType != "")
				{
					var obj = GOTUtil.getMainTable(extendsDataType) ;
					if(obj && obj.mainTable === tableR1.name)
					{
						queryTable1RelationItem = {qname:"QueryRelationItem",name:"A_QueryRelationItem",id:"2",
													Properties:{Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}}
												  };
						var dataType = obj.dataType;
						var normalRelationItem = GOTUtil.getNormalRelationItem(dataType);
						if(!normalRelationItem)
							throw new Error("DataType的Relation中没有Normal（没有指明其关联到主表的哪个字段）");

						var fieldPro = normalRelationItem.Properties.Field;
						
						var tableR1Field = fieldPro.V;
						var tableR1FieldId = fieldPro.refinnerid;
						fieldRelations.push({id:tableR1FieldId,value:tableR1Field});
						queryTable1RelationItem.Properties.Field.V = tableR1Field;
						queryTable1RelationItem.Properties.Field.refentityid = tableR1Id;
						queryTable1RelationItem.Properties.Field.refinnerid = tableR1FieldId;
						queryTable1RelationItem.Properties.ParentField.V = tableRNField.name;
						queryTable1RelationItem.Properties.ParentField.refentityid = tableRN.id;
						queryTable1RelationItem.Properties.ParentField.refinnerid = tableRNField.id;
						queryTable1RelationItem.name = tableR1.name + "." + tableR1Field + "=" + tableRN.name + "." + tableRNField.name;
						
						queryTable1Relation.Items.push(queryTable1RelationItem);
						
						
						var rtemp2 = JSON.parse(JSON.stringify(queryTable1RelationItem));
						
						var pFieldForDataField = rtemp2.Properties.Field;							
						var sDataField = pFieldForDataField.V;
						sDataField = sDataField.substr(0,1).toLowerCase() + sDataField.substring(1);
						rtemp2.dataField = sDataField;
						
						var pField = rtemp2.Properties.ParentField||rtemp2.Properties.RelatedField;
						pField.V = "";
						pField.refentityid;
						pField.refinnerid;
						
						queryTable1Relation.Items.push(rtemp2);
						
						var fixedItems = GOTUtil.getFixedRelationItem(dataType);
						for(var i = 0;i<fixedItems.length;i++)
						{
							var relationItem = fixedItems[i];
							queryTable1RelationItem = {qname:"QueryRelationItem",name:"A_QueryRelationItem",id:"2",
								Properties:{Field:{V:""},RelatedField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}}
						  	};
							fieldPro = relationItem.Properties.Field;
							valuePro = relationItem.Properties.FixedValue;
							queryTable1RelationItem.Properties.Field.V = fieldPro.V;
							queryTable1RelationItem.Properties.Field.refentityid = fieldPro.refentityid;
							queryTable1RelationItem.Properties.Field.refinnerid = fieldPro.refinnerid;
							queryTable1RelationItem.Properties.FieldValue.V = valuePro.V;
							queryTable1RelationItem.name = tableR1.name + "." + fieldPro.V + "=" + valuePro.V;
							queryTable1Relation.Items.push(queryTable1RelationItem);
							
						}
						
						break;
					}
				}
			}
		}
		
		
		return query;
	}


	static findWhereItemByField(field,alias,query,value = null)
	{
		var queryTable = QueryUtil.getQueryTableByAlias(alias,query);
		var queryTableTablePro = GOTUtil.getProperty(queryTable,"Table");
		var queryWhere = queryTable.QueryWhere;
		var queryWhereItem;
		var queryWhereItems = GOTUtil.getQueryWhereItemByPropertyValue(queryTable,"Field",field)
		if(queryWhereItems && queryWhereItems.length>0)
		{
			queryWhereItem = queryWhereItems[0];
			var status = GOTUtil.getPropertyValue(queryWhereItem,"Status");
			if(status != QueryWhereStatus.OPENLABEL)
				return null;
		}
		return queryWhereItem;
	}

	static findOrCreateWhereItemByField(tableField,field,alias,query,value = null)
	{
		var queryWhereItem = QueryUtil.findWhereItemByField(field,alias,query,value);
		if(value == ',')
			value = "','";
		if(queryWhereItem)
		{
			if(value!=null)
			{
				var valuePro = GOTUtil.getProperty(queryWhereItem, "Value");
				if(value == "" || !value)
				{
					if(!(typeof(value) == "number" && value == 0))
						value = "''";
				}
				valuePro.V = value;
			}
		}
		else
		{
			QueryUtil.createWhereItemByField(tableField,field,alias,query,value);
		}
	}
	
	static findOrCreateWhereItem(dataField,query,value = null)
	{
		var dataFieldArray = dataField.split(".");
		var tableAlias = dataFieldArray[0];
		var lowerTableField = dataFieldArray[1];
		var tableField = StringUtil.convertToFirstUpperCase(lowerTableField);
		if(dataFieldArray.length>3){
			lowerTableField = dataField.substring(dataField.indexOf('.')+1);
			tableField = lowerTableField;
		}
		var lowerComponentField = "";
		var componentField = "";
		if(dataFieldArray.length ==3 )
		{
			lowerComponentField = dataFieldArray[2];
			componentField = StringUtil.convertToFirstUpperCase(lowerComponentField);
		}
		var field = (componentField == "")?tableField:tableField+"."+componentField;
		
		QueryUtil.findOrCreateWhereItemByField(tableField,field,tableAlias,query,value);
	}

	static getAllOrderByItems(queryTable,array,del = false)
	{
		var orderBy = queryTable.QueryOrderBy;
		for(var i=0;i<orderBy.Items.length;i++){
			var item=orderBy.Items[i];
			if(!item.queryTableAlias)
			item.queryTableAlias=GOTUtil.getPropertyValue(queryTable,'Alias');
		}
		array.push.apply(array,orderBy.Items)
		if(del)
			orderBy.Items = [];
		var list = queryTable.QueryJoins.Items;
		// if(!list)
		if(list.length==0)
			return array;
		for(let i = 0;i<list.length;i++)
		{
			QueryUtil.getAllOrderByItems(list[i],array);
		}
	}

	static setCurrentQueryOrderByByDataField(dataField,query,sortType = null,byUser = false,cover = false)
	{
	    var dataFieldArray = dataField.split(".");
	    var tableAlias = dataFieldArray[0];
	    var lowerTableField = dataFieldArray[1];
	    var tableField = StringUtil.convertToFirstUpperCase(lowerTableField);
	    var lowerComponentField = "";var componentField = "";
	    if(dataFieldArray.length == 3)
	    {
	      lowerComponentField = dataFieldArray[2];
	      componentField = StringUtil.convertToFirstUpperCase(lowerComponentField);
	    }else if(dataFieldArray.length>3){
			tableField = dataField.substring(dataField.indexOf(".")+1);
		}
		
	    var field = (componentField == "")?tableField:(tableField+"."+componentField);
	    var queryTable = QueryUtil.getQueryTableByAlias(tableAlias,query);
	    var queryTableTablePro = GOTUtil.getProperty(queryTable,"Table");
	    var orderBy = queryTable.QueryOrderBy;var orderByItems = orderBy.Items;var orderByItem = null;
	    var allOrderByItems = [];
	    QueryUtil.getAllOrderByItems(query.QueryTable,allOrderByItems,byUser);
	   
	    for(let i = 0;i<allOrderByItems.length;i++)
	    {
	      var item = allOrderByItems[i];
	      if(item.hasOwnProperty("sorting"))
	        delete item.sorting;
	      if(!orderByItem && GOTUtil.getPropertyValue(item,"Field") == field && item.queryTableAlias ==tableAlias)
	        orderByItem = item; 
	    }
	  
	   
	    var orderByType; 
	    
	    //没有 加在第一个 若是点击的列头 那么固定为升序 若是右键菜单 则按照参数指定的
	    if(!orderByItem)
	    { 
		  if(sortType==null)return;
	      if(sortType != null)
	        orderByType = sortType;
	      else
	        orderByType = "ASC";
	      orderByItem = {
			name:"A_QueryOrderByItem",id:5,Properties:{Field:{V:""},OrderBy:{V:"ASC"}}
		  };
	      
	      orderByItem.sorting = true;
	      var fieldPro = GOTUtil.getProperty(orderByItem,"Field"); 
	      var orderByPro = GOTUtil.getProperty(orderByItem,"OrderBy"); 
	      
	      var temp = query.nextInnerId;orderByItem.id = temp;temp ++;
	      query.nextInnerId = temp;
	      orderByItem.name = tableField + " # " + orderByType;
	      fieldPro.V = field;
	      fieldPro.refentityid = queryTableTablePro.refentityid;
	      var tableXML = GOT.getTable(queryTableTablePro.refentityid);
	      var tableFieldXML = GOT.getTableField(tableXML,tableField);
	      fieldPro.refinnerid = tableFieldXML?tableFieldXML.id:"";
	      orderByPro.V = orderByType;
	      if(!orderBy.Items)
	      	orderBy.Items = [];
	      orderBy.Items.push(orderByItem);
	    }
	      //存在 提前 若是点击的列头 那么反转排序属性 若是右键菜单 则按照参数指定
	    else
	    {
			if(sortType==null){
				var _items = orderBy.Items;
				var childIndex = _items.indexOf(orderByItem);
				_items.splice(childIndex,1);
			}else{
				var tempItem = JSON.parse(JSON.stringify(orderByItem));
				orderByPro = GOTUtil.getProperty(tempItem,"OrderBy"); 
				fieldPro = GOTUtil.getProperty(tempItem,"Field");
				
				if(sortType)
				  orderByType = sortType;
				else
				{
				  orderByType = orderByPro.V;
				  orderByType = (orderByType == "ASC"?"DESC":"ASC");
				}
				orderByPro.V = orderByType;
				tempItem.name = fieldPro.V + " # " + orderByType;
				tempItem.sorting = true;
				var _items = orderBy.Items;
				var childIndex = _items.indexOf(orderByItem);
				_items.splice(childIndex,1);
				_items.unshift(tempItem);
			}
	    }
	}

	static formatEnumLabel(value,entityId,innerId)
	{
		var property = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,entityId,innerId);
		if(!property)
			return value;
		var dataProvider = [];
		if(property.hasOwnProperty("DataProvider"))
			 dataProvider = property.DataProvider;
		var func = function(args)
		{
			var a = "";
			if(args.length>0)a=args[0];
			for(let k = 0;k<dataProvider.length;k++)
			{
				let item = dataProvider[k]
				if(item.hasOwnProperty("value") && item.value == a)
				{
					return item.label;
				}
			}
			return a;
		};
		value = value.replace(/\d+/g,func);
		return value;


		var array = [];
		value = value+"";
		var values = value.split(",");
		for(let i=0;i<values.length;i++)
		{
			var s1 = values[i];
			var values1 = s1.split("..");
			for(let j = 0;j<values1.length;j++)
			{
				var s2 = values1[j];
				if(!isNaN(parseInt(s2)))
				{
					array.push(s2);		
				}
			}
			
		}
		var property = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,entityId,innerId);
		if(!property)
			return value;
		var dataProvider = [];
		if(property.hasOwnProperty("DataProvider"))
			 dataProvider = property.DataProvider;
		for(let i = 0;i<array.length;i++)
		{
			var a = array[i];
			for(let k = 0;k<dataProvider.length;k++)
			{
				let item = dataProvider[k]
				if(item.hasOwnProperty("value") && item.value == a)
				{
					value = value.replace(a,item.label)
				}
			}
			
		}
		
		return value;
	}

	static descendantsQueryTables(queryTable,results,parents)
	{
		results.push(queryTable);
		for(let i = 0;i<queryTable.QueryJoins.Items.length;i++)
		{
			let childQueryTable = queryTable.QueryJoins.Items[i];
			parents[childQueryTable.id] = queryTable;
			QueryUtil.descendantsQueryTables(childQueryTable,results,parents);
		}
	}

	static descendantsChildQueryTables(queryTable,results,parents,self = false)
	{
		if(self)
			results.push(queryTable);
		for(let i = 0;i<queryTable.QueryJoins.Items.length;i++)
		{
			let childQueryTable = queryTable.QueryJoins.Items[i];
			parents[childQueryTable.id] = queryTable;
			QueryUtil.descendantsChildQueryTables(childQueryTable,results,parents,true);
		}
	}

	static isJSON_test(str)
	{
		if (typeof str == 'string') {
		  try {
			let json = JSON.parse(str);
			if (typeof json == "object") {
			  return json;
			} else {
			  return false;
			}
		  } catch (e) {
			return false;
		  }
		}
		return true;  
	}

	static xmlQuery2JsonQuery(xml)
	{
		let result = QueryUtil.isJSON_test(xml);
		if (result == false) 
		{
			var x2js = new X2JS();
			xml = x2js.xml_str2json(xml).Query;
			var switchQueryTable = function(queryTable)
			{

				if(queryTable.Properties.UserUpdate.V == "true")
					queryTable.Properties.UserUpdate.V = true;
				else if(queryTable.Properties.UserUpdate == "false")
					queryTable.Properties.UserUpdate.V = false;

				if(queryTable.Properties.Output.V == "true")
					queryTable.Properties.Output.V = true;
				else if(queryTable.Properties.Output == "false")
					queryTable.Properties.Output.V = false;

				if(queryTable.tempTable == "true")
					queryTable.tempTable = true;
				else if(queryTable.tempTable == "false")
					queryTable.tempTable = false;
				
				if(queryTable.QueryWhere)
				{
					let queryWhereItem = queryTable.QueryWhere.QueryWhereItem;

					if(!queryWhereItem)queryTable.QueryWhere.Items = [];
					else if(Array.isArray(queryWhereItem))
					{
						
						for(let i = 0;i<queryWhereItem.length;i++)
						{
							let _queryWhereItem = queryWhereItem[i];
							_queryWhereItem.qname = "QueryWhereItem";
							if(_queryWhereItem.Properties.Enabled.V == "true")
								_queryWhereItem.Properties.Enabled.V = true;
							else if(_queryWhereItem.Properties.Enabled.V == "false")
								_queryWhereItem.Properties.Enabled.V = false;
						}
						queryTable.QueryWhere.Items = queryWhereItem;
					}
					else 
					{
						queryWhereItem.qname = "QueryWhereItem";
						if(queryWhereItem.Properties.Enabled.V == "true")
							queryWhereItem.Properties.Enabled.V = true;
						else if(queryWhereItem.Properties.Enabled.V == "false")
							queryWhereItem.Properties.Enabled = false;
						queryTable.QueryWhere.Items = [queryWhereItem];
					}
					delete queryTable.QueryWhere.QueryWhereItem;
				}
				if(queryTable.QueryRelation)
				{
					let queryRelationItem = queryTable.QueryRelation.QueryRelationItem;
					if(!queryRelationItem)queryTable.QueryRelation.Items = [];
					else if(Array.isArray(queryRelationItem))queryTable.QueryRelation.Items = queryRelationItem;
					else queryTable.QueryRelation.Items = [queryRelationItem];
					delete queryTable.QueryRelation.QueryRelationItem;

					if(queryTable.QueryRelation.Properties.Auto.V == "true")
						queryTable.QueryRelation.Properties.Auto.V = true;
					else if(queryTable.QueryRelation.Properties.Auto.V == "false")
						queryTable.QueryRelation.Properties.Auto.V = false;
					
					delete queryTable.QueryRelation.name;
				}

				if(queryTable.QueryOrderBy)
				{
					let queryOrderByItem = queryTable.QueryOrderBy.QueryOrderByItem;
					if(!queryOrderByItem)queryTable.QueryOrderBy.Items = [];
					else if(Array.isArray(queryOrderByItem))queryTable.QueryOrderBy.Items = queryOrderByItem;
					else queryTable.QueryOrderBy.Items = [queryOrderByItem];
					delete queryTable.QueryOrderBy.QueryOrderByItem;
				}

				if(queryTable.QueryJoins)
				{
					let queryJoinTable = queryTable.QueryJoins.QueryTable;
					if(!queryJoinTable)queryTable.QueryJoins.Items = [];
					else if(Array.isArray(queryJoinTable))queryTable.QueryJoins.Items = queryJoinTable;
					else queryTable.QueryJoins.Items = [queryJoinTable];
					delete queryTable.QueryJoins.QueryTable;
					for(let i = 0;i<queryTable.QueryJoins.Items.length;i++)
					{
						let queryJoinTableItem = queryTable.QueryJoins.Items[i];
						switchQueryTable(queryJoinTableItem);
					}
				}

				if(queryTable.QueryFields)
				{
					delete queryTable.QueryFields.name;
					if(queryTable.QueryFields.Properties.Auto.V == "true")
						queryTable.QueryFields.Properties.Auto.V = true;
					else if(queryTable.QueryFields.Properties.Auto.V == "false")
						queryTable.QueryFields.Properties.Auto.V = false;
					queryTable.QueryFields.Items = [];
				}

				if(queryTable.QueryAggregations)
				{
					queryTable.QueryAggregations.Items = [];
				}

			}

			switchQueryTable(xml.QueryTable);
		}
		else if(typeof(result) == "object")
		{
			xml = result;
		}

		if(xml.Properties.UseCache)
		{
			if(xml.Properties.UseCache.V == "true")
				xml.Properties.UseCache.V = true;
			else if(xml.Properties.UseCache.V == "false")
				xml.Properties.UseCache.V = false;
		}

		let xmlCopy = JSON.parse(JSON.stringify(xml));
		QueryUtil.TempTest(xmlCopy);
		//Warn.show({text:JSON.stringify(xmlCopy)});

		return xml;
	}

	static TempTest(xml)
	{
		delete xml.name;
		delete xml.nextInnerId;
		delete xml.direction;
		delete xml.toEnd;
		delete xml.needRefresh;
		delete xml.name;
		delete xml.qname;
		delete xml.fileName;
		var switchQueryTable = function(queryTable)
		{
			delete queryTable.name;
			delete queryTable.id;
			
			if(queryTable.QueryWhere)
			{
				let items = queryTable.QueryWhere.Items;
				for(let i = 0;i<items.length;i++)
				{
					let _queryWhereItem = items[i];
					delete _queryWhereItem.name;
					delete _queryWhereItem.qname;
					delete _queryWhereItem.tag;
					delete _queryWhereItem.id;
				}
				
			}

			if(queryTable.QueryOrderBy)
			{
				let items = queryTable.QueryOrderBy.Items;
				for(let i = 0;i<items.length;i++)
				{
					let _queryOrderByItem = items[i];
					delete _queryOrderByItem.name;
					delete _queryOrderByItem.id;
				}
				
			}
			
			if(queryTable.QueryRelation)
			{
				for(let i = 0;i<queryTable.QueryRelation.Items.length;i++)
				{
					let queryRelationItem = queryTable.QueryRelation.Items[i];
					delete queryRelationItem.qname;
					delete queryRelationItem.name;
					delete queryRelationItem.id;
				}
			}

			if(queryTable.QueryJoins)
			{
				for(let i = 0;i<queryTable.QueryJoins.Items.length;i++)
				{
					let queryJoinTableItem = queryTable.QueryJoins.Items[i];
					switchQueryTable(queryJoinTableItem);
				}
			}
		}

		switchQueryTable(xml.QueryTable);
	}


	static queryCalculationOperator(query){

		let queryTable = query.QueryTable;
		let tableName = GOTUtil.getPropertyValue(queryTable,"Table");
		let tablePro = GOTUtil.getProperty(queryTable,"Table");
		let userInfos=window.parent.window.userInfos?window.parent.window.userInfos:window.userInfos;
		let queryWildcardCharacter="*";
		if(userInfos.WILDCARD){
			queryWildcardCharacter= userInfos.WILDCARD;
		}


		for(let i in queryTable.QueryWhere.Items){
			let whereItem = queryTable.QueryWhere.Items[i];
			if(GOTUtil.getPropertyValue(whereItem,"Fieldflag")){
				let tableFiled = GOT.getTableFieldById(tablePro.refentityid,GOTUtil.getProperty(whereItem,"Field").refinnerid);
				let type = tableFiled.type;
				let flag = GOTUtil.getPropertyValue(whereItem,"Fieldflag");
				if(flag=='开头是'){
					whereItem.Properties.Value.V = "#like("+whereItem.Properties.Value.V+"%)"
				}else if(flag=='开头不是'){
					whereItem.Properties.Value.V = "!("+whereItem.Properties.Value.V+queryWildcardCharacter+")"
				}else if(flag=='结尾是'){
					whereItem.Properties.Value.V = "#like(%"+whereItem.Properties.Value.V+")"
				}else if(flag=='结尾不是'){
					whereItem.Properties.Value.V = "!("+queryWildcardCharacter+whereItem.Properties.Value.V+")"
				}else if(flag=='包含'){
					whereItem.Properties.Value.V = "#like(%"+whereItem.Properties.Value.V+"%)"
				}else if(flag=='不包含'){
					whereItem.Properties.Value.V = "!("+queryWildcardCharacter+whereItem.Properties.Value.V+queryWildcardCharacter+")"
				}else if(flag=='为空'|| flag=='空'){
					whereItem.Properties.Value.V = "#null"
				}else if(flag=='非空' ){
					whereItem.Properties.Value.V = "#notNull"
				}else if(flag=='列表内'){
					whereItem.Properties.Value.V = "#in("+whereItem.Properties.Value.V+")"
				}else if(flag=='列表外'){
					whereItem.Properties.Value.V = "#notIn("+whereItem.Properties.Value.V+")"
				}else if(flag=='等于' ){
					whereItem.Properties.Value.V = "="+whereItem.Properties.Value.V
				}else if(flag=='不等于'){
					if(type=="String" ){
						whereItem.Properties.Value.V = "!="+whereItem.Properties.Value.V
					}else{
						whereItem.Properties.Value.V = "<>"+whereItem.Properties.Value.V
					}
				}else if(flag=='大于'){
					whereItem.Properties.Value.V = ">"+whereItem.Properties.Value.V
				}else if(flag=='大于等于'){
					whereItem.Properties.Value.V = ">="+whereItem.Properties.Value.V
				}else if(flag=='小于'){
					whereItem.Properties.Value.V = "<"+whereItem.Properties.Value.V
				}else if(flag=='小于等于'){
					whereItem.Properties.Value.V = "<="+whereItem.Properties.Value.V
				}else if(flag=='介于'){
					// whereItem.Properties.Value.V = "#notLike(%"+whereItem.Properties.Value.V+")"
				}else if(flag=='今天'){
					if(type =='Date'){
						let  today = new Date();
						let formattedDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
						whereItem.Properties.Value.V = formattedDate;
					}
					if(type=="Time"){
						let now = new Date();
						let formattedTime = now.getHours() + '-' + pad(now.getMinutes(),2) + '-' + pad(now.getSeconds(),2);
						whereItem.Properties.Value.V = formattedTime;
					}
					if(type=="DateTime"){
						let today = new Date();
						let formattedDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
						let formattedTime = today.getHours() + '-' + pad(today.getMinutes(),2) + '-' + pad(today.getSeconds(),2);
						whereItem.Properties.Value.V = formattedDate+" "+formattedTime;
					}
				}else if(flag=='是'){
					if(type == "Boolean"){
						whereItem.Properties.Value.V ="true"
					}

				}else if(flag=='不是'){
					if(type == "Boolean"){
						whereItem.Properties.Value.V ="false"
					}
				}
			}
		}
		if(queryTable.QueryJoins)
		{
			for(let i = 0;i<queryTable.QueryJoins.Items.length;i++)
			{
				let queryJoinTableItem = queryTable.QueryJoins.Items[i];
				queryCalculationOperator(queryJoinTableItem);
			}
		}

	}
	static queryWhereItemRemoveFlag(whereItem,temp){
		let userInfos=window.parent.window.userInfos?window.parent.window.userInfos:window.userInfos;
		let queryWildcardCharacter="*";
		if(userInfos.WILDCARD){
			queryWildcardCharacter= userInfos.WILDCARD;
		}
		let flag = GOTUtil.getPropertyValue(whereItem,"Fieldflag");
		let value = GOTUtil.getPropertyValue(whereItem,"Value");
		if(value.startsWith("!=") || value.startsWith("<>") || value.startsWith("<=") || value.startsWith(">=")){
			if(!flag){
				if(value.startsWith("!=") ){
					temp.tfieldflag = "不等于";
				}else if(value.startsWith("<>")){
					temp.tfieldflag = "不等于";
				}else if(value.startsWith("<=")){
					temp.tfieldflag = "小于等于";
				}else if(value.startsWith(">=")){
					temp.tfieldflag = "大于等于";
				}
			}
			value=value.substring(2,value.length);
		}else if(value.startsWith("<") || value.startsWith(">") || value.startsWith("=") ){
			if(!flag){
				if(value.startsWith("=") ){
					temp.tfieldflag = "等于";
				}else if(value.startsWith("<")){
					temp.tfieldflag = "小于";
				}else if(value.startsWith(">")){
					temp.tfieldflag = "大于";
				}
			}
			value=value.substring(1,value.length);


		}else if(value.startsWith("#null")  || value.startsWith("#notNull") ){
			if(!flag){
				if(value.startsWith("#null") ){
					temp.tfieldflag = "为空";
				}else if(value.startsWith("#notNull")){
					temp.tfieldflag = "非空";
				}
			}
			value="";

		}else if(value.startsWith("#in")  ){
			if(!flag){

				temp.tfieldflag = "列表内";

			}
			value=value.substring(4,value.length-1);
		}else if(value.startsWith("#notIn")  ){
			if(!flag){
				if(value.startsWith("#notIn") ){
					temp.tfieldflag = "列表外";
				}
			}
			value=value.substring(7,value.length-1);
		}else if(value.startsWith("#like")  ){
			if(!flag){
				if(value.substring(5,6)==queryWildcardCharacter && value.substring(value.length-2,value.length-1)!=queryWildcardCharacter){
					temp.tfieldflag = "开头是";
				}else if(value.substring(5,6)!=queryWildcardCharacter && value.substring(value.length-2,value.length-1)==queryWildcardCharacter){
					temp.tfieldflag = "结尾是";
				}else if(value.substring(5,6)==queryWildcardCharacter && value.substring(value.length-2,value.length-1)==queryWildcardCharacter){
					temp.tfieldflag = "包含";
				}
			}
			if(flag=='开头是'){
				value=value.substring(6,value.length-2); 
			}else if(flag=='结尾是'){
				value=value.substring(7,value.length-1);
			}else if(flag=='包含'){
				value=value.substring(7,value.length-2);
			}
		}else if(value.startsWith("!(")  ){
			if(!flag){
				if(value.substring(2,3)==queryWildcardCharacter && value.substring(value.length-2,value.length-1)!=queryWildcardCharacter){
					temp.tfieldflag = "开头不是";
				}else if(value.substring(2,3)!=queryWildcardCharacter && value.substring(value.length-2,value.length-1)==queryWildcardCharacter){
					temp.tfieldflag = "结尾不是";
				}else if(value.substring(2,3)==queryWildcardCharacter && value.substring(value.length-2,value.length-1)==queryWildcardCharacter){
					temp.tfieldflag = "不包含";
				}
			}
			 if(flag=='开头不是'){
				value=value.substring(2,value.length-2);
			}else if(flag=='结尾不是'){
				value=value.substring(3,value.length-1);
			}else if(flag=='不包含'){
				value=value.substring(3,value.length-2);
			}
		}else if(value.length>=3 && value.substring(value.length-2,value.length)==queryWildcardCharacter+queryWildcardCharacter){
			if(!flag){
				temp.tfieldflag = "包含";
			}
			value = value.substring(0,value.length-2);
		}else if(value.length>=2 && value.substring(value.length-1,value.length)==queryWildcardCharacter){
			if(!flag){
				temp.tfieldflag = "开头是";
			}
			value = value.substring(0,value.length-1);
		}else if(value.length>=2 && value.substring(value.length-1,value.length)!=queryWildcardCharacter && value.substring(0,1)==queryWildcardCharacter){
			if(!flag){
				temp.tfieldflag = "结尾是";
			}
			value = value.substring(1,value.length);
		}else if(value.length>=2 && value.substring(value.length-1,value.length)==queryWildcardCharacter && value.substring(0,1)==queryWildcardCharacter){
			if(!flag){
				temp.tfieldflag = "包含";
			}
			value = value.substring(1,value.length-1);
		}
		else if(value=="true" || value==true){
			if(!flag){
				temp.tfieldflag = "是";
			}
		}else if(value=="false" || value==false){
			if(!flag){
				temp.tfieldflag = "不是";
			}
		}
			// }else if(value.startsWith("!(")  && value.substr(value.length-1,value.length)==")"){
			// 	value=value.substring(2,value.length-1);
			// }

		whereItem.Properties.Value.V=value;
	}
	
}


// WEBPACK FOOTER //
// ./src/utils/QueryUtil.js